(() => {
  const trigger = document.querySelector('[data-kaw-back-to-top]');
  if (!trigger) return;

  const controller = new AbortController();
  const { signal } = controller;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const getScroller = () => {
    const wrapper = document.querySelector('.page-wrapper');
    if (wrapper && wrapper.scrollHeight > wrapper.clientHeight) return wrapper;
    return document.scrollingElement;
  };

  let scrollFrame = 0;

  trigger.addEventListener(
    'click',
    (event) => {
      event.preventDefault();
      cancelAnimationFrame(scrollFrame);
      const scroller = getScroller();
      scroller.style.scrollBehavior = 'auto';
      if (reduced) {
        scroller.scrollTop = 0;
        scroller.style.scrollBehavior = '';
        return;
      }
      const start = scroller.scrollTop;
      const duration = 800;
      const t0 = performance.now();
      const swing = (t) => 0.5 - Math.cos(t * Math.PI) / 2;
      const step = (now) => {
        const progress = Math.min((now - t0) / duration, 1);
        scroller.scrollTop = start - start * swing(progress);
        if (progress < 1) {
          scrollFrame = requestAnimationFrame(step);
        } else {
          scroller.style.scrollBehavior = '';
        }
      };
      scrollFrame = requestAnimationFrame(step);
    },
    { signal }
  );

  window.addEventListener('pagehide', () => controller.abort(), { signal });
})();

(() => {
  const toggles = document.querySelectorAll('[data-kaw-credits-toggle]');
  const panel = document.getElementById('kaw-footer-credits');
  if (!toggles.length || !panel) return;

  const controller = new AbortController();
  const { signal } = controller;

  const setExpanded = (expanded) => {
    panel.hidden = !expanded;
    toggles.forEach((toggle) => toggle.setAttribute('aria-expanded', String(expanded)));
  };

  toggles.forEach((toggle) => {
    toggle.addEventListener(
      'click',
      () => setExpanded(toggle.getAttribute('aria-expanded') !== 'true'),
      { signal }
    );
  });

  window.addEventListener('pagehide', () => controller.abort(), { signal });
})();
